import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";

interface Props {
  message: string;
  open: boolean;
  onClose: () => void;
}

const ConcurrentModificationWarningDialog = ({ message, open, onClose }: Props) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <SmallDialog open={open} onClose={onClose}>
      <DialogTitle>Data Updated</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <WarningDialogIcon sx={{ width: 80, height: 80 }} />
          <Typography variant="subtitle2">{message}</Typography>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose} cancelText="Close">
        <Button variant="contained" onClick={handleRefresh}>
          Refresh
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default ConcurrentModificationWarningDialog;
